exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popper[data-v-aae4f0c0]{box-shadow:0 10px 50px 0 rgba(0,0,0,.2);transition:all .3s ease-out 0s}", ""]);

// exports
